import { includes } from 'lodash';
import { DeviceModelEnumComponent } from '../../../../enumComponent/DeviceModelEnumComponent/DeviceModelEnumComponent';
import {
  AssignDeviceInfo, DeviceModelEnum
} from '../../../../uc-api-sdk';
import { SupportDeviceInfoComponent } from '../SupportDeviceInfoComponent/SupportDeviceInfoComponent';
import { DeviceImageComponent } from '../../DeviceImageComponent';
import { CGMDeviceNameComponent, CGMDeviceNameComponentProps } from '../../../CGMDevice/component/CGMDeviceNameComponent/CGMDeviceNameComponent';

type ExtendedAssignDeviceInfo = AssignDeviceInfo & {
  brand?: CGMDeviceNameComponentProps['brand'];
  model?: CGMDeviceNameComponentProps['model'];
};

export interface DeviceLabelComponentProps {
  device?: ExtendedAssignDeviceInfo;
  deviceModel?: AssignDeviceInfo['deviceModel'];
  showSupportDevice?: boolean;
  showImage?: boolean;
}

export const DeviceLabelComponent = ({
  device,
  deviceModel = device?.deviceModel,
  showSupportDevice = true,
  showImage = true,
}: DeviceLabelComponentProps) => {
  const renderSupportDeviceInfo = () => {
    const isBPM1 = includes(
      [DeviceModelEnum.BPM1, DeviceModelEnum.BPM1_HOTSPOT],
      deviceModel
    );
    if (deviceModel && isBPM1) {
      return (
        <>
          {' '}
          <span>+</span>
          {' '}
          <SupportDeviceInfoComponent
            deviceModel={deviceModel}
            showImage={showImage}
          />
        </>
      );
    }
    return null;
  };

  const renderModel = () => {
    if (device?.deviceModel === DeviceModelEnum.CGM) {
      return (
        <CGMDeviceNameComponent
          brand={device.brand}
          model={device.model}
        />
      );
    }
    return <DeviceModelEnumComponent value={deviceModel ?? undefined} />;
  };

  return (
    <>
      {
        showImage
        && (
          <DeviceImageComponent
            deviceModel={deviceModel ?? undefined}
          />
        )
      }
      <span>
        {renderModel()}
      </span>
      {
        showSupportDevice
        && renderSupportDeviceInfo()
      }
    </>
  );
};
